import { DetalleTareaService } from './../../admin/detalle-tareas/detalle-tareas-service';
import { UtilsService } from './../../utils-service';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Tarea } from 'app/models/tareas.model';
import { CompletarGestionService } from '../modal-completar-gestion/completar-gestion.service';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { CompletarGestionSinBienService } from './completar-gestion-sin-asociar-bien.service';
import { Plantilla } from 'app/modules/admin/documentos-oficiales/models/plantillas.model';
import { CompletarGestionInteface } from './completar-gestion-sin-asociar-bien.model';

@Component({
    selector: 'completar-gestion-sin-asociar-bie',
    templateUrl: 'completar-gestion-sin-asociar-bien.component.html',
    imports: [ CommonModule, MatButtonModule, MatIconModule, MatFormFieldModule, FormsModule, MatInputModule, MatSelectModule ]
})

export class CompletarGestionSinAsociarBienComponent implements OnInit {
    @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
    detalleTarea: Tarea
    isDraggingOver = false;
    documentos: File[] = [];
    uuidDocumentoOficial:string
    nombreDocumentoSeleccionado:string
    plantillas: Plantilla[]=[]
    payloadGestionCompletada:CompletarGestionInteface
    isSubmitting: boolean = false
    
    constructor(
        public dialogRef: MatDialogRef<CompletarGestionSinAsociarBienComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Tarea,
        private completarGestionService:CompletarGestionService,
        private CompletarGestionSinBienService: CompletarGestionSinBienService,
        private _detalleTareasService: DetalleTareaService,
        private UtilsService: UtilsService
    ) { 
        this.detalleTarea= this.data
        this.payloadGestionCompletada = {
            gestionUuid: this.detalleTarea?.tareaUuid ?? '',
            documentoFirmado: 0,
            plantilla: 0,
            codigoDocumento: '',
            fechaInicioVigencia: '',
            fechaFinVigencia: '',
            generadoPor: ''
        }
    }

    ngOnInit() {
        this.getListadoPlantillas(this.detalleTarea.seccion.tipologiaId)
     }

    finalizarYEnviar(){
        // Asegura mapeo del documento subido al payload
        if (this.uuidDocumentoOficial) {
            this.payloadGestionCompletada.documentoFirmado = this.uuidDocumentoOficial;
        }
        this.payloadGestionCompletada.gestionUuid = this.detalleTarea?.tareaUuid ?? '';

        this.isSubmitting = true;
        this.CompletarGestionSinBienService.completargestionSinBien(this.payloadGestionCompletada)
        .then((response:any) => {
            this.dialogRef.close(true);
            this._detalleTareasService.getActividadesByTask(this.detalleTarea.tareaUuid)
            this._detalleTareasService.getTaskDetails(this.detalleTarea.tareaUuid)
            this.UtilsService.openSuccessSnakBar(response.message)
        })
        .catch(() => {
            this.isSubmitting = false;
        })
        .finally(() => {
            this.isSubmitting = false;
        })
    }

    uploadImage() {
        this.fileInput.nativeElement.click();
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDraggingOver = true;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.isDraggingOver = false;
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        this.isDraggingOver = false;
        if (event.dataTransfer?.files.length > 0) {
        this.handleFiles(event.dataTransfer.files);
        }
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files?.length) {
        this.handleFiles(input.files);
        }
    }

    handleFiles(files: FileList) {
        const formData = new FormData();
    
        if (files.length > 0) {
            this.nombreDocumentoSeleccionado = files[0].name;
        }

        Array.from(files).forEach(file => {
            formData.append('files', file);
            formData.append('documentoOficial', 'true');
        });

        this.completarGestionService.postDocumentosGestion(formData, this.detalleTarea.tareaUuid)
        .then((response: any)=>{
            this.payloadGestionCompletada.documentoFirmado= response.data
        })
    }

    getListadoPlantillas(seccionId:number){
        this.CompletarGestionSinBienService.getPlantillas(seccionId)
        .then((response:Plantilla[])=>{
                this.plantillas = response
            }
        )
    }   

}
